export default __webpack_public_path__ + "static/media/printing.b8cc6297.svg";